import { mapActions } from 'vuex'
import { CCDB_CLEAR, CCDB_CONTACT_METHOD_TYPES, CCDB_DETAILS, CCDB_ORDER_DETAILS } from '@/store/types'

export default
{
	props:
	{
		ccdbId:
		{
			type:    [ Number, String ],
			default: null,
		},

		orderId:
		{
			type:    String,
			default: null,
		},

		ccdbToOrderId:
		{
			type:    [ Number, String ],
			default: null,
		},
	},

	beforeRouteEnter(to, from, next)
	{
		next
		(
			vm =>
			{
				vm.clearCcdb()
				vm.getDetails()
			}
		)
	},

	computed:
	{
		isProfile()
		{
			return this.isRoute('profile.*')
		},
	},

	methods:
	{
		...mapActions
		({
			clearCcdb:              CCDB_CLEAR,
			loadCcdb:               CCDB_DETAILS,
			loadCcdbOrder:          CCDB_ORDER_DETAILS,
			loadContactMethodTypes: CCDB_CONTACT_METHOD_TYPES,
		}),

		getDetails()
		{
			if ( this.isProfile )
			{
				return this.getContactDetails()
			}

			return Promise.all
			([
				this.getOrderContactDetails(),
				this.loadContactMethodTypes()
			])
		},

		getContactDetails()
		{
			return this.loadCcdb({ ccdbId: this.ccdbId })
		},

		getOrderContactDetails()
		{
			return this.loadCcdbOrder({ orderId: this.orderId, ccdbToOrderId: this.ccdbToOrderId })
		},
	},
}